import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_PRE_REGISTRATIONS, 
    ADD_NEW_PRE_REGISTRATION, 
    UPDATE_PRE_REGISTRATION, 
    DELETE_PRE_REGISTRATION,
    APPROVE_PRE_REGISTRATION,
    REJECT_PRE_REGISTRATION,
    GET_PRE_REGISTRATION_BY_UUID

} from "./actionTypes";

import {
    getPreRegistrationsSuccess,
    getPreRegistrationsFail,
    addPreRegistrationSuccess,
    addPreRegistrationFail,
    updatePreRegistrationSuccess,
    updatePreRegistrationFail,
    deletePreRegistrationSuccess,
    deletePreRegistrationFail,

    approvePreRegistrationSuccess,
    approvePreRegistrationFail, 
    rejectPreRegistrationSuccess,
    rejectPreRegistrationFail,

    getPreRegistrationByUuidSuccess,
    getPreRegistrationByUuidFail,
   
} from "./actions"

import {
    getPreRegistrations,
    addNewPreRegistration,
    updatePreRegistration,
    deletePreRegistration,

    approvePreRegistration, 
    rejectPreRegistration,
    getPreRegistrationByUuid,
   
} from "helpers/pre-registrations/pre_registrations_backend_helper";
import { toast } from "react-toastify";


/*
function* fetchPreRegistrations() {
    try {
        const response = yield call(getPreRegistrations)

        console.log("RESPONSE: ", response);
        yield put(getPreRegistrationsSuccess(response))
    } catch (error) {
        yield put(getPreRegistrationsFail(error))
    }
}
*/

function* fetchPreRegistrations({ payload }) {
  try {
    // payload = filters envoyés depuis le composant
    const response = yield call(getPreRegistrations, payload || {});
    yield put(getPreRegistrationsSuccess(response))
  } catch (error) {
    yield put(getPreRegistrationsFail(error))
  }
}

function* onAddNewPreRegistration({ payload }) {
    try {

        
        const response = yield call(addNewPreRegistration, payload)

        console.log("RESPONSE:", response);
        yield put(addPreRegistrationSuccess(response.preRegistration))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(addPreRegistrationFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}



function* onUpdatePreRegistration({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updatePreRegistration, payload)
        yield put(updatePreRegistrationSuccess(response.preRegistration))
        toast.success(response.data.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updatePreRegistrationFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeletePreRegistration({ payload: data }) {

    try {
        const response = yield call(deletePreRegistration, data)
        yield put(deletePreRegistrationSuccess(response.preRegistrationId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deletePreRegistrationFail(error))
        toast.error("Branch  Deleted Failed", { autoClose: 2000 });
    }
}

function* onApprovePreRegistration({ payload}) {
    try {
        
        const response = yield call(approvePreRegistration, payload)

        console.log("VALIDATION RESPONSE: ", response);
        yield put(approvePreRegistrationSuccess(response.preRegistration))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(approvePreRegistrationFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onRejectPreRegistration({ payload}) {
    try {
       
        const response = yield call(rejectPreRegistration, payload)

        yield put(rejectPreRegistrationSuccess(response.preRegistration))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(rejectPreRegistrationFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onGetPreRegistrationByUuid({ payload }) {
  try {
    const response = yield call(getPreRegistrationByUuid, payload);
    yield put(getPreRegistrationByUuidSuccess(response));
  } catch (error) {
    yield put(getPreRegistrationByUuidFail(error));
  }
}


function* preRegistrationSaga() {
    yield takeEvery(GET_PRE_REGISTRATIONS, fetchPreRegistrations)
    yield takeEvery(ADD_NEW_PRE_REGISTRATION, onAddNewPreRegistration)
    yield takeEvery(UPDATE_PRE_REGISTRATION, onUpdatePreRegistration)
    yield takeEvery(DELETE_PRE_REGISTRATION, onDeletePreRegistration)
    yield takeEvery(APPROVE_PRE_REGISTRATION, onApprovePreRegistration)
    yield takeEvery(REJECT_PRE_REGISTRATION, onRejectPreRegistration)
    yield takeEvery(GET_PRE_REGISTRATION_BY_UUID, onGetPreRegistrationByUuid)
}

export default preRegistrationSaga;